import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "./brand/Logo";
import { ShieldCheck, Lock, Globe } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 border-t border-gold-dim/30 bg-navy-deep" data-testid="site-footer">
    <div className="container-wide py-12 md:py-14 grid sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
      <div>
        <BrandLogo />
        <p className="mt-4 text-sm text-cream-dim leading-relaxed">
          Governance, cybersecurity, and infrastructure transparency for
          municipal governments, data centers, and public accountability.
        </p>
        <div className="mt-5 flex gap-3 text-gold">
          <ShieldCheck size={18} /><Lock size={18} /><Globe size={18} />
        </div>
      </div>
      <FooterCol title="Platform" links={[
        ["Platform Overview", "/platform"],
        ["Cybersecurity Layer", "/cybersecurity"],
        ["Budget Scanner", "/budget-scanner"],
        ["Infrastructure Risk", "/infrastructure"],
        ["Demo Mode", "/demo"],
        ["Civic Data Crawler", "/demo/civic-data-search"],
        ["Budget Crawler", "/demo/budget-crawler"],
        ["Public Records", "/demo/public-records"],
      ]} />
      <FooterCol title="Solutions" links={[
        ["Sports + Health IQ", "/auditiq-sports"],
        ["Command Center", "/auditiq-sports/command-center"],
        ["Sports Demo", "/auditiq-sports/demo"],
        ["Data Center Water", "/solutions/data-center-water"],
        ["Government Eight", "/government-eight"],
        ["Certification", "/certification"],
        ["Video Demo", "/video-demo"],
        ["Case Studies", "/case-studies"],
        ["Pricing / Pilot", "/pricing"],
      ]} />
      <FooterCol title="Company" links={[
        ["About", "/about"],
        ["Contact", "/contact"],
        ["Security & Compliance", "/security"],
        ["Privacy", "/privacy"],
        ["Terms", "/terms"],
        ["Admin", "/admin/login"],
      ]} />
    </div>
    <div className="border-t border-gold-dim/20">
      <div className="container-wide py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-steel text-center md:text-left">
        <div>© {new Date().getFullYear()} AuditIQ. GovTech accountability platform.</div>
        <div className="flex items-center gap-3">
          <Link
            to="/security"
            data-testid="footer-security-badge"
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded border border-gold/50 text-gold hover:border-gold hover:bg-gold/10 transition-colors uppercase tracking-[0.18em]"
            style={{ fontFamily: "Cinzel, Georgia, serif", fontSize: 10, letterSpacing: "0.18em" }}
          >
            <ShieldCheck size={11} />
            Security &amp; Compliance
          </Link>
          <span className="tracking-[0.2em] uppercase">Defensive · Transparent · Non-partisan</span>
        </div>
      </div>
    </div>
  </footer>
);

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.2em] text-gold mb-4">{title}</div>
    <ul className="flex flex-col gap-2">
      {links.map(([l, to]) => (
        <li key={to}><Link to={to} className="text-sm text-cream-dim hover:text-gold transition-colors">{l}</Link></li>
      ))}
    </ul>
  </div>
);

export default Footer;
